import React, { useState } from "react";
import bg from "../../../assets/images/yzqf/glpbg.jpg";
import glpbgcont from "../../../assets/images/yzqf/glpbg-cont.png";
import JYGQ from "./JYGQ";
import CQQY from "./CQQY";
import XSYJ from "./XSYJ";
import GRSC from "./GRSC";
function GLP({ setShow }) {
  const [type, setType] = useState("");
  const typeimg = Array(4)
    .fill()
    .map((_, index) =>
      require(`../../../assets/images/yzqf/glp-type${index + 1}.png`)
    );

  return (
    <div className="common-page">
      <img src={bg} alt="" />
      <img className="glppagecont" src={glpbgcont} alt="" />
      <ul className="glptype">
        {["jygq", "cqqy", "xsyz", "grsc"].map((item, index) => {
          return (
            <li
              onClick={() => {
                setType(item);
              }}
              key={index}
              className={`animate__animated animate__fadeInUp animate__delay-0${
                index + 1
              }s`}>
              <img src={typeimg[index]} alt="" />
            </li>
          );
        })}
      </ul>
      {type === "jygq" && <JYGQ setType={setType} />}
      {type === "cqqy" && <CQQY setType={setType} />}
      {type === "xsyz" && <XSYJ setType={setType} />}
      {type === "grsc" && <GRSC setType={setType} />}

      <div
        className="back"
        onClick={() => {
          setShow("studyroom");
        }}></div>
    </div>
  );
}

export default GLP;
